import { css } from '@emotion/react';
import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthMediumExtended, widthSmall, widthLarge } = breakpoints;
const S = {};

S.ProductComparison = styled.section`
  label: ProductComparison;
  text-align: center;
`;

S.ProductComparison.Title = styled.h2`
  label: Title;

  margin-bottom: 0.5rem;
`;

S.ProductComparison.SubTitle = styled.h3`
  label: SubTitle;

  color: var(--colors-scarpa-flow);
  margin-bottom: 2rem;

  @media (${widthSmall}) {
    margin-bottom: 3rem;
  }
`;

S.ProductComparison.ProductsHolder = styled.div`
  label: ProductsHolder;

  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  justify-content: center;
  margin-bottom: 1rem;

  @media (${widthSmall}) {
    margin-bottom: 1rem;
    grid-template-columns: minmax(auto, 43rem);
    gap: 1.25rem;
  }

  @media (${widthMediumExtended}) {
    grid-template-columns: repeat(
      ${({ isMultiTier }) =>
        isMultiTier ? '3,  1fr' : '2,  minmax(auto, 18.625rem)'}
    );
    gap: 1.5rem;
    align-items: end;
  }

  @media (${widthLarge}) {
    ${({ isMultiTier }) =>
      !isMultiTier &&
      css`
        grid-template-columns: repeat(2, minmax(auto, 23.125rem));
      `};
  }
`;

S.ProductComparison.Availability = styled.div`
  label: Availability;

  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  justify-content: center;
  color: var(--colors-silver-chalice);
  padding-bottom: 2rem;

  @media (${widthSmall}) {
    width: 100%;
  }

  @media (${widthMediumExtended}) {
    margin: auto;
  }
`;

export default S;
